module.exports = __webpack_public_path__ + "img/home_16.bb179b11.svg";